export default __webpack_public_path__ + "static/media/flowxo.55e7ffb9.svg";